export default __webpack_public_path__ + "static/lefafa_1_1-ffa2d82af0a58f18066ef12a6c21af18.webp";